import { EventEmitter, Injectable, NgZone } from '@angular/core';
import { RoutingService } from './routing-service';
import { ProvidehttpService } from './providehttp.service';
import { Data } from './DataService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AlertsService } from './AlertsService';
import { HttpResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { MobileService } from './mobile.services';
import { RetailStock } from './retail-common.service';
import { SpinnerService } from './services/spinner/spinner.service';
import { OnboardingService } from './onboarding.service';
import { KeycloakLoginOptions } from 'keycloak-js';
import { AccountOnboarding } from './accountonboarding.service';
import { FcmNotificationService } from './fcm-notification.service';
import { DeviceDetectorService, DeviceType } from 'ngx-device-detector';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
import { CustomerInfo } from './models/customer-info.model';
import { CustomerService } from './services/customer.service';
import { RateService } from './services/rate/rate.service';
import { PreLoginService } from './pre-login/pre-login.service';

declare let window: any;
declare var cordova: any;
declare let $: any;

@Injectable({
  providedIn: 'root'
})
export class ServiceStock {
  /*SANTHOSH 12-DEC-2021 BEGIN*/
  private desktopVersion: boolean;
  private mobileVersion: boolean;
  private tabletVersion: boolean;

  bankName = 'PNG';

  public initializeUIClass() {
    this.desktopVersion = this.deviceService.getDeviceInfo().deviceType == DeviceType.Desktop;
    this.tabletVersion = this.deviceService.getDeviceInfo().deviceType == DeviceType.Tablet;
    this.mobileVersion = this.deviceService.getDeviceInfo().deviceType == DeviceType.Mobile;
  }

  public isDesktop(): boolean {
    return this.desktopVersion;
  }

  public isTablet(): boolean {
    return this.tabletVersion;
  }

  public isMobile(): boolean {
    return this.mobileVersion;
  }

  public isHybrid() {
    return window["cordova"] ? true : false;
  }
  /*SANTHOSH 12-DEC-2021 END*/
  constructor(public routing: RoutingService,
    private spinnerService: SpinnerService,
    public http: ProvidehttpService,
    public dataStore: Data,
    public modal: NgbModal,
    public translate: TranslateService,
    public router: Router,
    public alert: AlertsService,
    public ngZone: NgZone,
    public authService: AuthService,
    public mobile: MobileService,
    public retailStock: RetailStock,
    public onboarding: OnboardingService,
    private deviceService: DeviceDetectorService,
    public accountOnboarding: AccountOnboarding,
    public fcmService: FcmNotificationService,
    public alertsService: AlertsService,
    private customerService:CustomerService,
    private baseRateService : RateService,
    private _loginService : PreLoginService
  ) {

    router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event) => {
      console.log(event, "Router");
      $('app-root').animate({ 'scrollTop': 0 }, 'fast');
    });

    this.screenHeight = screen.height;
    window.addEventListener('onForceLogout', this.forceLogout, false);
    window.addEventListener('updateScreenHeight', this.updateScreenHeight.bind(this), false);

    if (this.mobile.isHybrid()) {
      this.dataStore.loadData('userData').then(
        (data) => {
          this.userProfile = JSON.parse(data);
          for (let datakey in this.userProfile) {
            console.log(datakey, this.userProfile[datakey]);
            sessionStorage.setItem(datakey, this.userProfile[datakey]);
          }
        },
        (error) => {
          console.log('no stored user!');
        }
      )
    }
  }

  public loadLandingSpinner;
  public getUserProfile: any = {};
  public workspace;
  public userProfile;
  public isUserSignup: boolean = false;
  public screenHeight: number;
  public bonusEligibility
  public greenifyEnabled

  greenAtleastOnce = ''

  /*SANTHOSH 30/09/2021 BEGIN*/
  //userLoggedIn function moved to data store service

  /*SANTHOSH 30/09/2021 END*/

  formatAmount(number, languageCode, minFraction) {
    return number.toLocaleString(languageCode, { minimumFractionDigits: minFraction });
  }
  maskAccountNo(number) {
    return number.slice(0, -4).replace(/./g, '*') + number.slice(-4);
  }

  getCurrencySign(currency) {
    return "$";
  }

  getEnvironment() {
    return environment;
  }

  getUserImage(successCallback) {
    this.retailStock.getUserImage(successCallback);
  }

  helloText() {
    return this.retailStock.helloText()
  }

  loadAccountSummary() {
    /*var _this = this;
    this.retailStock.getAccountSummary(function (fullUserProfileData) {
      _this.getUserProfile = fullUserProfileData;
    });*/
  }

  showSpinner() {
    this.spinnerService.show();
  }

  hideSpinner() {
    this.spinnerService.hide();
  }

  auditRouter(navPath) {
    this.retailStock.auditRouter(navPath);
  }

  showWSLoader(doShow) {
    if (doShow) {
      document.body.style.overflow = "hidden";
      document.getElementById('wsloader').style.display = "block";
    } else {
      document.body.style.overflow = "unset";
      document.getElementById('wsloader').style.display = "none";
    }
  }

  restrictAutofill(e) {
    var _$ = window["$"];
    setTimeout(function () {
      var name = _$(e.target).attr('name');
      if (_$('input[name=' + name + ']:-webkit-autofill').length) {
        //var text = _$(e.target).val();
        _$(e.target).after(e.target.outerHTML).remove();
        _$('input[name=' + name + ']').val('');
      }
    }, 20);
  }

  logout() {
    const logoutEvent = new CustomEvent('onlogout', { detail: this });
    window.dispatchEvent(logoutEvent);
  }

  forceLogout(e: any = undefined) {
    var _this = this;
    if (e) _this = e.detail;
    let wasTapped = sessionStorage.getItem("wasTapped");
    sessionStorage.clear();
    if (wasTapped) sessionStorage.setItem("wasTapped", "true");
    _this.getUserProfile = null;
    this._loginService.refreshTokenService?.stop();
    _this.authService.logout();
    if (_this.mobile.isDeviceRegistered) {
      sessionStorage.setItem('appAlreadyLaunched', "true");
    }
    if (_this.dataStore.isHybrid()) {
      document.body.style.transition = "all .4s";
      document.body.style.opacity = "0";
      setTimeout(function () {
        window.location = "index.html";
      }, 1000);
    }
  }

  onUserRegistrationSuccess() {
    //this.fcmService.updateToken();

    let successMsg = "";
    let _path = '/welcome/welcomeuser';
    if (this.isUserSignup) { //this.onboarding.isRegistration
      _path = '/staging/requestSelfie';
      successMsg = "Registration<br>successful!";
      let inputMap = new Map();
      var navPath = ('/staging/acknowledge').split('/');
      navPath = navPath.slice(1);
      inputMap.clear();
      inputMap.set('title', successMsg);
      inputMap.set('info', "Welcome to PNG. We’re happy that you joined. Let’s personalize your profile with an image.");
      inputMap.set('gotoPath', _path);
      this.dataStore.setRouteParams(this.routing.currModal, inputMap);
      if (this.routing.currModal > 0) {
        var routerOutlets = {};
        routerOutlets[this.routing.currOutlet] = [navPath[navPath.length - 1], 'popup'];
        this.router.navigate([{ outlets: routerOutlets }], { skipLocationChange: true });
      } else {
        this.router.navigate(navPath);
      }
    } else {
      //successMsg = "Login<br>successful!";
      this.router.navigate([_path]);
    }
  }

  public triggerStaging$ = new Subject<boolean>();
  triggerStaging(val) {
    return this.triggerStaging$.next(val);
  }

  getStaginTrigger(): Observable<any> {
    return this.triggerStaging$.asObservable();
  }

  /**
   * To apply min height for the form entry screen to align frm-actionbutton bottom
   */
  updateScreenHeight() {
    let contentEl = $(".bi-reponsive");
    contentEl.addClass('min-height');
    let safeAreaHeight = $(".top-notch-area").height() || 0;

    let headerHeight = 0;
    if ($(".main-header").length) headerHeight = $(".main-header")[0].offsetHeight || 0;
    let minHeight = this.screenHeight - (safeAreaHeight + headerHeight) - (this.mobile.keyboardHeight);
    contentEl[0].style.minHeight = minHeight + 'px';
    if ($(".frm-actions-group").length) {
      let footerHeight = $(".frm-actions-group")[0].offsetHeight;
      contentEl[0].style.paddingBottom = (footerHeight + 28) + 'px';
    }
  }

  onFetchDeaftDataSuccess() {
    this.hideSpinner();
    if (this.accountOnboarding.isApplicationDataAvailable) {
      sessionStorage.setItem("entryFromPreLogin", "1");
      sessionStorage.setItem('forceResume', "1");
      this.router.navigate(['/home/openAccount']);
    } else {
      this.router.navigate(['/accountOpening/newAccountTypes']);
    }
  }

  async onLoginSuccess() {
    this.baseRateService.fetchBaseRateCurrency();

    if (sessionStorage.getItem("notificationOn")) {
      this.dataStore.setUserLoggedIn(true);
      this.showSpinner();
      this.retailStock.fetchUserDetails().subscribe(
        async (httpResponse: HttpResponse<any>) => {
          this.hideSpinner();
          var res = httpResponse.body;

          this.dataStore.customerInfo = res['customer'];

          if (httpResponse.status == 200) {
            this.bonusEligibility = res.bonusEligibility;
            this.userProfile["firstName"] = res.personalDetails["firstName"];
            this.userProfile["lastName"] = res.personalDetails["lastName"];
            this.router.navigate(['/home/redeem']);

          }
        },
        async (httpError) => {
          var err = httpError["error"];
          if (
            err != null &&
            err["ErrorElementPath"] != undefined &&
            err["ErrorDescription"] != undefined
          ) {
          }
          this.hideSpinner();
          this.router.navigate(['/home/redeem']);
        }
      );

      return;
    }
    else if (sessionStorage.getItem('doOpenNewAccount') && sessionStorage.getItem('doOpenNewAccount') == '1') {
      sessionStorage.removeItem('doOpenNewAccount');
      if (localStorage.getItem("hasAcc") == "true") {
        this.router.navigate(['/welcome/welcomeuser']);
      } else {
        this.showSpinner();
        this.accountOnboarding.fetchDraftData(this.onFetchDeaftDataSuccess.bind(this));
      }
    } else if (
      sessionStorage.getItem('flex_pay_initiation') && sessionStorage.getItem('flex_pay_initiation') == "1") {
      sessionStorage.removeItem("flex_pay_initiation");
      this.router.navigate(["/home/flexpay/confirmation"]);
    } else {
      this.dataStore.setUserLoggedIn(false);
      if (sessionStorage.getItem('inAccOpeningWay') == "1") {
        const resumeLastActionEvt = new CustomEvent('resumeLastAction', { detail: this });
        window.dispatchEvent(resumeLastActionEvt);
      } else {

        this.dataStore.loadData('userData').then(
          async (data) => {
            this.userProfile = JSON.parse(data);
            sessionStorage.setItem("customerCode", this.userProfile.customerCode);
            //this.fcmService.updateToken();
            this.showSpinner();
            this.customerService.fetchCustomerInfo(this.userProfile.customerCode).subscribe(
              async(res: CustomerInfo) => {
                if(res){
                  this.hideSpinner();
                  console.log("4: received customer details");
                  this.router.navigate(["/welcome/welcomeuser"]);
                }
              },
              async (httpError) => {
                var err = httpError["error"];
                if (
                  err != null &&
                  err["ErrorElementPath"] != undefined &&
                  err["ErrorDescription"] != undefined
                ) {
                }
                this.hideSpinner();
              }
            );
          },
          (error) => {
            console.log('load user data error!');
          }
        );
      }
    }
  }

  async donationGreenify() {
    this.showSpinner();

    let inputMap = new Map();
    let apiName = "/donation";
    const greenifyTrxData = JSON.parse(sessionStorage.getItem('donation_greenify'));
    inputMap.set("Body.donation", greenifyTrxData);

    console.log(greenifyTrxData);

    sessionStorage.removeItem('donation_greenify')
    await this.http.fetchApi(apiName, "POST", inputMap, this.getEnvironment().accountsPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;

        let accHistory$ = new Observable<boolean>((observer) => {
          this.retailStock.refreshHistory(observer);
        });

        accHistory$.subscribe((res) => {
          if (res) {
            if (this.isDesktop()) {
              const doRefreshEvt = new CustomEvent('refreshForm', {});
              window.dispatchEvent(doRefreshEvt);
            }
            this.router.navigate(['/home/transactions']);
            this.hideSpinner();
          }
        });

      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
        }
        const alertData = {
          showAlert: true,
          type: 'Failed',
          title: 'Something went wrong!',
          message: 'Your account seams to have an insufficient balance for this transaction. Therefore the transaction could not be executed.',
          btn: { label: 'Try later', action: 'close' }
        }
        this.router.navigate(['/home/transactions']);
        this.alertsService.updateAlert(alertData);
        this.hideSpinner();
      }
    );
  }
}
